"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPaymentValue = exports.setPaymentValue = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    initialContribution: 0,
    creditTerm: 0,
};
var paymentSlice = (0, toolkit_1.createSlice)({
    name: 'payment',
    initialState: initialState,
    reducers: {
        setPaymentValue: function (state, action) {
            state.creditTerm = action.payload.creditTerm;
            state.initialContribution = action.payload.initialContribution;
        },
        resetPaymentValue: function (state) {
            state.creditTerm = 0;
            state.initialContribution = 0;
        },
    },
});
exports.setPaymentValue = (_a = paymentSlice.actions, _a.setPaymentValue), exports.resetPaymentValue = _a.resetPaymentValue;
exports.default = paymentSlice.reducer;
